module.exports = __webpack_public_path__ + "assets/img/mr6.a25e5b2c.png";